import RemoteSensorDetail from "@/components/Elemnt/RemoteSensors/RemoteSensorDetail";
import { useParams } from "react-router";

function SensorPage() {
  const { appToken = "", remoteSensorId = "" } = useParams();
  return <RemoteSensorDetail appToken={appToken} remoteSensorId={+remoteSensorId} />;
}

export default SensorPage;
